
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPartlycloudyPolartwilightColour as ObiPartlycloudyPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-partlycloudy-polartwilight-colour.js';
 
 
 

 
 export const ObiPartlycloudyPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-partlycloudy-polartwilight-colour',
   elementClass: ObiPartlycloudyPolartwilightColourElement,
   events: {
     
   }
  });
 
 